/* ============================================================
   TEXTIL-WARENKORB
   Laeuft auf jeder Seite (eingebunden in snippets/zx-head.liquid).
   Haelt die Veredelungs-Zeilen des Textil-Konfigurators stimmig:
    - Menge der Veredelung = Summe der Textilien derselben Konfiguration
      (Eigenschaft _zx_cfg). Textilien weg -> Veredelung weg.
    - Staffelpreis = Summe aller Textilien mit demselben Verfahren
      (_zx_verfahren: stick / druck / namen) im ganzen Warenkorb.
      Falsche Staffel-Variante wird ersetzt (entfernen + neu hinzufuegen,
      alle Eigenschaften inkl. Logo-Upload-Link bleiben erhalten).
    - Mengenfeld/Loeschen-Knopf der Veredelungs-Zeilen ausgeblendet.
    - Mindestmenge je Veredelungs-Zeile: Hinweis + Kasse gesperrt.
   Spezifikation: docs/specs/2026-10-01-textil-konfigurator-design.md
   ============================================================ */
(function () {
  'use strict';
  var el = document.getElementById('zxt-warenkorb-config');
  if (!el) return;
  var C = JSON.parse(el.textContent);
  if (!C.handle || !C.varianten || !C.varianten.length) return;

  var laeuft = false, nochmal = false;

  function staffel(n) {
    var lab = C.staffeln[0];
    C.staffeln.forEach(function (s) { if (n >= parseInt(s, 10)) lab = s; });
    return lab;
  }
  function variante(stufe, n) {
    var m = staffel(Math.max(1, n));
    return C.varianten.find(function (v) { return v.stufe === stufe && v.menge === m; });
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function holeWarenkorb() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function sauber(props) {
    var p = {};
    Object.keys(props || {}).forEach(function (k) { if (props[k] != null && props[k] !== '') p[k] = props[k]; });
    return p;
  }

  /* Gibt true zurueck, wenn der Warenkorb geaendert wurde */
  async function abgleichen() {
    if (laeuft) { nochmal = true; return false; }
    laeuft = true;
    var geaendert = false;
    try {
      var cart = await holeWarenkorb();
      var textil = {}, vered = [], verfProCfg = {}, summe = {};
      cart.items.forEach(function (it) {
        var p = it.properties || {}, cfg = p._zx_cfg;
        if (!cfg) return;
        if (it.handle === C.handle) {
          vered.push(it);
          (verfProCfg[cfg] = verfProCfg[cfg] || {})[p._zx_verfahren] = true;
        } else {
          textil[cfg] = (textil[cfg] || 0) + it.quantity;
        }
      });
      Object.keys(verfProCfg).forEach(function (cfg) {
        Object.keys(verfProCfg[cfg]).forEach(function (v) { summe[v] = (summe[v] || 0) + (textil[cfg] || 0); });
      });

      var updates = {}, neu = [];
      vered.forEach(function (it) {
        var p = it.properties, soll = textil[p._zx_cfg] || 0;
        if (!soll) { updates[it.key] = 0; return; }
        var ziel = variante(p._zx_stufe, summe[p._zx_verfahren] || soll);
        if (ziel && ziel.id !== it.variant_id) {
          updates[it.key] = 0;
          neu.push({ id: ziel.id, quantity: soll, properties: sauber(p) });
        } else if (it.quantity !== soll) {
          updates[it.key] = soll;
        }
      });
      if (Object.keys(updates).length) { await post('/cart/update.js', { updates: updates }); geaendert = true; }
      if (neu.length) { await post('/cart/add.js', { items: neu }); geaendert = true; }
    } catch (e) {
      /* Abgleich ist best effort - beim naechsten Warenkorb-Update erneut */
    } finally {
      laeuft = false;
    }
    if (nochmal) { nochmal = false; return (await abgleichen()) || geaendert; }
    return geaendert;
  }

  /* Drawer + Warenkorb-Symbol neu laden, ohne Dawns Ablauf zu stoeren */
  async function neuZeichnen(oeffnen) {
    if (/^\/(\w{2}(-\w{2})?\/)?cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) { if (oeffnen) window.location.href = '/cart'; return; }
    var r = await fetch('/?sections=cart-drawer,cart-icon-bubble');
    var s = await r.json();
    var parse = function (html, sel) { return new DOMParser().parseFromString(html, 'text/html').querySelector(sel); };
    /* "leer"-Markierung am Drawer immer an den neuen Stand anpassen - sonst
       blendet Dawn Kopf und Artikelliste aus (nur die Summe bliebe sichtbar) */
    var neuEl = parse(s['cart-drawer'], 'cart-drawer');
    var istLeer = !!(neuEl && neuEl.classList.contains('is-empty'));
    drawer.classList.toggle('is-empty', istLeer);
    if (oeffnen && typeof drawer.renderContents === 'function') {
      drawer.renderContents({ id: null, sections: s });
    } else {
      var neuDrawer = parse(s['cart-drawer'], '#CartDrawer');
      var alt = document.getElementById('CartDrawer');
      if (neuDrawer && alt) alt.innerHTML = neuDrawer.innerHTML;
      var bubble = document.getElementById('cart-icon-bubble');
      var neuBubble = parse(s['cart-icon-bubble'], '.shopify-section');
      if (bubble && neuBubble) bubble.innerHTML = neuBubble.innerHTML;

    }
    setTimeout(markieren, 0);
  }

  /* Veredelungs-Zeilen markieren, Mengen sperren, Mindestmenge pruefen */
  function markieren() {
    var zuWenig = [];
    document.querySelectorAll('#CartDrawer .cart-item, #main-cart-items .cart-item').forEach(function (row) {
      var link = row.querySelector('a[href*="/products/' + C.handle + '"]');
      if (!link) return;
      row.classList.add('zxt-vered');
      var inp = row.querySelector('input.quantity__input');
      if (inp) {
        inp.readOnly = true;
        inp.tabIndex = -1;
        if (parseInt(inp.value, 10) < C.min) zuWenig.push(row);
      }
      if (!row.querySelector('.zxt-vered__hinweis')) {
        var h = document.createElement('p');
        h.className = 'zxt-vered__hinweis';
        h.textContent = 'Menge folgt automatisch deinen Textilien.';
        var ziel = row.querySelector('.cart-item__details') || row;
        ziel.appendChild(h);
      }
    });
    ['#CartDrawer-Checkout', '#checkout'].forEach(function (sel) {
      var btn = document.querySelector(sel);
      if (!btn) return;
      var box = btn.parentElement;
      var hinweis = box && box.querySelector('.zxt-moq');
      if (zuWenig.length) {
        btn.disabled = true;
        btn.dataset.zxtGesperrt = '1';
        if (box && !hinweis) {
          hinweis = document.createElement('p');
          hinweis.className = 'zxt-moq';
          hinweis.setAttribute('role', 'alert');
          hinweis.textContent = 'Mindestens ' + C.min + ' Stück je Veredelungs-Position – bitte Menge der Textilien erhöhen.';
          box.insertBefore(hinweis, btn);
        }
      } else if (btn.dataset.zxtGesperrt) {
        btn.disabled = false;
        delete btn.dataset.zxtGesperrt;
        if (hinweis) hinweis.remove();
      }
    });
  }

  async function nachUpdate() {
    var geaendert = await abgleichen();
    if (geaendert) await neuZeichnen(false);
    else markieren();
  }

  window.zxTextilWarenkorb = { abgleichen: abgleichen, neuZeichnen: neuZeichnen, markieren: markieren };

  function start() {
    markieren();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(nachUpdate, 50); });
    }
    /* Dawn zeichnet Drawer/Warenkorbseite nach Mengenaenderung neu -> erneut markieren */
    ['CartDrawer', 'main-cart-items'].forEach(function (id) {
      var n = document.getElementById(id);
      if (n) new MutationObserver(function () { markieren(); }).observe(n, { childList: true, subtree: true });
    });
    /* Beim Laden einmal abgleichen (Warenkorb evtl. auf anderem Weg geaendert) */
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (bubble) nachUpdate();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
